import React from "react";
import { createRoot } from "react-dom/client";
import "./Reboot.css";
// import "./Bootstrap.css";
import "./Bootstrap.css";
import "./index.css";

import App from "./App";
// import register from "./registerServiceWorker";
import Intl18nProvider from "./Containers/Intl18n/Intl18nProvider";
import { Provider } from "react-redux";
import store from "./store";
import GlobalLoader, {
  GlobalLoadingProvider
} from "./Components/GlobalLoader/GlobalLoader";
import { ToastProvider } from "./Components/Toast/ToastProvider";
import { GoogleMapsProvider } from "./Containers/GoogleMaps/GoogleMaps";
import { MaintenanceProvider } from "./Containers/Maintenance/Maintenance";
import { RealTimeProvider } from "./Containers/RealTime/RealTime";
import RealTimeEntityUpdater from "./Containers/RealTime/RealTimeEntityUpdater";
import { OneSignalPlayerIdProvider } from "./Helpers/OneSignalHelper";
import NotificationSoundProvider from "./Components/NotificationSoundProvider/NotificationSound";
// import { testCondition } from "./Components/FilterList/AdvancedFilter/AdvancedFilterColors";
// testCondition

if (process.env.NODE_ENV !== "production") {
  const nativeWarn = console.warn.bind(console);
  const nativeError = console.error.bind(console);
  const suppressedPatterns = [
    "Support for defaultProps will be removed from function components in a future major release",
    "findDOMNode is deprecated in StrictMode.",
    "Warning: findDOMNode is deprecated in StrictMode."
  ];

  console.warn = (...args) => {
    if (
      typeof args[0] === "string" &&
      suppressedPatterns.some((pattern) => args[0].includes(pattern))
    ) {
      return;
    }
    nativeWarn(...args);
  };

  console.error = (...args) => {
    if (
      typeof args[0] === "string" &&
      suppressedPatterns.some((pattern) => args[0].includes(pattern))
    ) {
      return;
    }
    nativeError(...args);
  };
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <OneSignalPlayerIdProvider>
      <Intl18nProvider>
        <RealTimeProvider>
          <RealTimeEntityUpdater>
            <ToastProvider portalElem={document.body}>
              <GoogleMapsProvider>
                <GlobalLoadingProvider>
                  <MaintenanceProvider>
                    <NotificationSoundProvider>
                      <GlobalLoader />
                      <App />
                    </NotificationSoundProvider>
                  </MaintenanceProvider>
                </GlobalLoadingProvider>
              </GoogleMapsProvider>
            </ToastProvider>
          </RealTimeEntityUpdater>
        </RealTimeProvider>
      </Intl18nProvider>
    </OneSignalPlayerIdProvider>
  </Provider>
);

// ReactDOM.render(

// 	document.getElementById("root")
// );

// register();
